import React from 'react'
import { Outlet } from 'react-router-dom'
import { useTheme, useMediaQuery } from '@mui/material'
import { useSelector } from 'react-redux'

import './LayoutWrapper.css'
import Header from './Header'
import BurgerMenu from './BurgerMenu'

const LayoutWrapper = () => {
    const theme = useTheme()

    return (
        <div className="layout-wrapper">
            {/* Sidebar */}
            <BurgerMenu />

            {/* Main Content */}
            <main className='main-content'>
                {/* Header */}
                <Header />

                {/* Page Content */}
                <div className="page-content">
                    <Outlet />
                </div>
            </main>
        </div>
    )
}

export default LayoutWrapper
